import { position2dSchema, scale2dSchema, sideSchema, size2dSchema } from '@/domain/shared/commonSchemas';
import { boolean, number, object, string, type InferType } from 'yup';

// Optional dimension schema — mirrors imageFieldSchema.optionalSize2dSchema.
// Kept local so this file doesn't need to grow a shared helper.
const optionalSize2dSchema = object({
    height: number().required(),
    width: number().required(),
})
    .default(undefined)
    .nullable();

const textboxFieldSchema = object({
    characterSpacing: number().nullable().defined(),
    color: string().required(),
    fontFamily: string().required(),
    fontSize: number().positive().required(),
    frameSize: optionalSize2dSchema,
    id: string().required(),
    isBold: boolean().required(),
    isItalic: boolean().required(),
    isLocked: boolean().required(),
    isUnderlined: boolean().required(),
    kind: string()
        .oneOf(['textbox'] as const)
        .required(),
    lineSpacing: number().nullable().defined(),
    placeholder: string().nullable().defined(),
    position: position2dSchema,
    rotationDeg: number().required(),
    scale: scale2dSchema,
    side: sideSchema,
    size: size2dSchema,
    // Per-character styles map mirroring fabric.js's shape
    // ({ [line]: { [char]: attrs } }). Runtime shape validated by
    // the type system; Yup only asserts it's an object literal here
    // to avoid duplicating the nested schema — the domain uses
    // TTextStyles for the strong typing.
    styles: object().required(),
    text: string().defined(),
    textAlign: string()
        .oneOf(['center', 'justify', 'left', 'right'] as const)
        .required(),
});

type TTextboxFieldJSONData = InferType<typeof textboxFieldSchema>;

export { textboxFieldSchema };
export type { TTextboxFieldJSONData };
